module.exports = __webpack_public_path__ + "img/nav-close.fdeefd72.svg";